// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-card, .simple-card-disabled {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--d-spacing-double);
  color: black;
  margin-bottom: var(--d-spacing-double);
  font-size: medium;
}

.simple-card-disabled {
  display: block;
  padding-bottom: var(--d-spacing-half);
  background-color: var(--ion-color-medium);
  opacity: 0.6;
  color: rgba(0, 0, 0, 0.87);
  box-shadow: 0 0 0 0;
}

.simple-card-title {
  font-size: 16px;
  font-weight: 500;
  color: var(--ion-color-primary);
  line-height: 150%;
  flex-grow: 1;
}

.simple-card-button, .simple-card-button-red {
  flex-shrink: 0;
  --border-radius: 100%;
  --background: var(--ion-color-secondary);
  --border-color: white;
  --border-width: 0.1em;
  --color: white;
  --padding-start: 0.3em;
  --padding-end: 0.3em;
  --padding-top: 0.3em;
  --padding-bottom: 0.3em;
  --box-shadow: var(--d-box-shadow);
  margin: 0 0 0 calc(var(--d-spacing-single) / 2);
  width: 2em;
  height: 2em;
}

.simple-card-button-red {
  --border-color: var(--ion-color-secondary);
  --background: white;
}

.simple-card-disabled-text {
  font-size: 16px;
  font-weight: 500;
  color: var(--ion-color-primary);
  line-height: 150%;
  transform: translateY(0.7vh);
  text-align: end;
  width: 100%;
  color: var(--ion-color-primary);
  font-size: x-small;
}

ion-button[shape=round] {
  height: 28px;
  width: 28px;
}

ion-card {
  box-shadow: var(--d-box-shadow);
}`, "",{"version":3,"sources":["webpack://./src/app/common/components/simple-card/dwin-simple-card.component.scss","webpack://./src/mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EAEA,gCAAA;EACA,YAAA;EACA,sCAAA;EACA,iBAAA;AAFJ;;AAKA;EAEI,cAAA;EACA,qCAAA;EAEA,yCAAA;EACA,YAAA;EACA,0BAAA;EAEA,mBAAA;AAJJ;;AAOA;ECjBI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;EDgBA,YAAA;AADJ;;AAIA;EACI,cAAA;EACA,qBAAA;EACA,wCAAA;EACA,qBAAA;EACA,qBAAA;EACA,cAAA;EACA,sBAAA;EACA,oBAAA;EACA,oBAAA;EACA,uBAAA;EACA,iCAAA;EACA,+CAAA;EACA,UAAA;EACA,WAAA;AADJ;;AAIA;EAEI,0CAAA;EACA,mBAAA;AAFJ;;AAKA;EC7CI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,iBAAA;ED4CA,4BAAA;EACA,eAAA;EACA,WAAA;EACA,+BAAA;EACA,kBAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;AACJ;;AAEA;EACI,+BAAA;AACJ","sourcesContent":["@import 'src/mixins.scss';\n\n.simple-card {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    padding: var(--d-spacing-double);\n    color: black;\n    margin-bottom: var(--d-spacing-double);\n    font-size: medium;\n}\n\n.simple-card-disabled {\n    @extend .simple-card;\n    display: block;\n    padding-bottom: var(--d-spacing-half);\n\n    background-color: var(--ion-color-medium);\n    opacity: 0.6;\n    color: rgba(0, 0, 0, 0.87);\n    -webkit-box-shadow: 0 0 0 0;\n    box-shadow: 0 0 0 0;\n}\n\n.simple-card-title {\n    @include p1-style;\n    flex-grow: 1;\n}\n\n.simple-card-button {\n    flex-shrink: 0;\n    --border-radius: 100%;\n    --background: var(--ion-color-secondary);\n    --border-color: white;\n    --border-width: 0.1em;\n    --color: white;\n    --padding-start: 0.3em;\n    --padding-end: 0.3em;\n    --padding-top: 0.3em;\n    --padding-bottom: 0.3em;\n    --box-shadow: var(--d-box-shadow);\n    margin: 0 0 0 calc(var(--d-spacing-single) / 2);\n    width: 2em;\n    height: 2em;\n}\n\n.simple-card-button-red {\n    @extend .simple-card-button;\n    --border-color: var(--ion-color-secondary);\n    --background: white;\n}\n\n.simple-card-disabled-text {\n    @include p1-style;\n    transform: translateY(0.7vh);\n    text-align: end;\n    width: 100%;\n    color: var(--ion-color-primary);\n    font-size: x-small;\n}\n\nion-button[shape='round'] {\n    height: 28px;\n    width: 28px;\n}\n\nion-card {\n    box-shadow: var(--d-box-shadow);\n}\n","@mixin h1-style {\n    font-size: 19px;\n    font-weight: bold;\n    color: var(--ion-color-primary);\n    line-height: 130%;\n}\n\n@mixin p1-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p1-berry-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n\n@mixin p1-white-style {\n    font-size: 16px;\n    font-weight: 500;\n    color: white;\n    line-height: 150%;\n}\n\n@mixin p2-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-primary);\n    line-height: 150%;\n}\n\n@mixin p2-berry-style {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-secondary);\n    line-height: 150%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
